<template>
  <div class="home">
    <hkcmaPage/>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import hkcmaPage from '@/components/hkcmaPage.vue'; // @ is an alias to /src

export default defineComponent({
  name: 'hkcmaView',
  components: {
    hkcmaPage,
  },
});
</script>
